import { JsonObject, JsonProperty } from 'json2typescript';
import { ShopStatisticPackage } from './shop-statistic-package.model';

@JsonObject('ShopStatistic')
export class ShopStatistic {

  @JsonProperty('day_timestamp', Number)
  dayTimestamp: number = 0;

  @JsonProperty('price_amount_total', Number)
  priceAmountTotal: number = 0;

  @JsonProperty('shop_packages', [ShopStatisticPackage])
  shopPackages: ShopStatisticPackage[] = [];
}
